/**
 * Paginación premium compartida — Médicos / Administrativos visibilidad.
 */
export function AmvTablePager({
  rangeStart,
  rangeEnd,
  filteredCount,
  totalCount,
  searchActive,
  page,
  totalPages,
  pageSize,
  onPageChange,
  entityLabel = 'registros'
}) {
  if (filteredCount === 0) return null;

  const showNav = pageSize > 0;

  return (
    <div className="crm-amv-pager">
      <div className="crm-amv-pager__meta">
        Mostrando <strong>{rangeStart}</strong>–<strong>{rangeEnd}</strong> de{' '}
        <strong>{filteredCount}</strong>
        {searchActive ? ` (filtrado de ${totalCount})` : ''}
      </div>
      {showNav ? (
        <nav className="crm-amv-pager__nav" aria-label={`Paginación de ${entityLabel}`}>
          <button
            type="button"
            className="crm-amv-pager__btn"
            onClick={() => onPageChange(1)}
            disabled={page <= 1}
            aria-label="Primera página"
          >
            «
          </button>
          <button
            type="button"
            className="crm-amv-pager__btn"
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={page <= 1}
            aria-label="Página anterior"
          >
            ‹
          </button>
          <span className="crm-amv-pager__current">
            Página <strong>{page}</strong> de {totalPages}
          </span>
          <button
            type="button"
            className="crm-amv-pager__btn"
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            disabled={page >= totalPages}
            aria-label="Página siguiente"
          >
            ›
          </button>
          <button
            type="button"
            className="crm-amv-pager__btn"
            onClick={() => onPageChange(totalPages)}
            disabled={page >= totalPages}
            aria-label="Última página"
          >
            »
          </button>
        </nav>
      ) : null}
    </div>
  );
}

export default AmvTablePager;
